import React, {useState} from 'react';
 
import { Form, Button, Row, Col, ListGroup, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAlignLeft,faXmark, faFileExce } from "@fortawesome/free-solid-svg-icons"; 
import { Link} from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
 
 
 
import Rightbar from './Rightbar';
  
export default function ExhibitorPortalhome(){ 
    const [date, setDate] = useState(new Date());
const [sidebar, setsidebar] = useState(false);
const [mainbar, setmainbar] = useState(false);
const toggle = () => {
    setsidebar(!sidebar);
    setmainbar(!mainbar);
}
const [selected, setSelected] = useState([]);
const options = [
    { label: "Select1", value: "select1" },
    { label: "Select2", value: "select2" },
    { label: "Select3", value: "select3" },
  ];

return(
  <>
<section className="sec-container" >
   <div className='container'>
      <div className='portalevent'>
         <div className='row'>
            <div className={`col-md-3 portal-sidebar leftbar-close ${sidebar ? 'close' : ''}`}>
                  <div >
                  <Rightbar/>
                  </div>
               </div>
               <div className={`col-md-9 rightbar-open ${mainbar ? 'open' : ''}`}>
                  <div className='rightbar '>
                  <Button variant="outline-info" onClick={toggle}>
                    <FontAwesomeIcon icon={faAlignLeft} />
                  </Button>
                  <h1>GUEST LIST</h1>
                  <div className="gry-bg">
                            <p><strong>
                                All exhibitors receive the following VIP passes and photo l.a. programming tickets:</strong>
                            </p>
                             
                                <li>25 VIP passes for your collectors </li>
                                <li>25 VIP passes for your social media followers  </li>
                                <li>5 one-time-use tickets for photo l.a. or FOCUS photo l.a. programming events for your collectors  </li>
                           
                            <br/>
                            <p>
                                VIP passes give access to the VIP preview and VIP programs along with general 
                                admission to exhibitor programming and content. Links to the VIP early access events 
                                will be sent to you via email. Please send any guest-related questions to 
                                vip@photola.com
                            </p>
                      </div>

                            <Form>
                                <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                    <Form.Label column sm={2} style={{"textAlign": "left"}}>
                                        Type of Guest<span className='star'>*</span>
                                    </Form.Label>
                                    <Col sm={10}>
                                    <MultiSelect
        options={options}
        value={selected}
        onChange={setSelected}
        labelledBy="Select"
 
      />
                                        
                                        
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                    <Form.Label column sm={2} style={{"textAlign": "left"}}>
                                        Delivery Method<span className='star'>*</span>
                                    </Form.Label>
                                    <Col sm={10}>
                                        <Form.Select aria-label="Default select example">
                                            <option>Please Select</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                            <option value="3">Three</option>
                                        </Form.Select>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                    <Form.Label column sm={2} style={{"textAlign": "left"}}>
                                        First Name<span className='star'>*</span>
                                    </Form.Label>
                                    <Col sm={10}>
                                        <Form.Control type="text" placeholder="" />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                    <Form.Label column sm={2} style={{"textAlign": "left"}}>
                                        Last Name<span className='star'>*</span>
                                    </Form.Label>
                                    <Col sm={10}>
                                        <Form.Control type="text" placeholder="" />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                    <Form.Label column sm={2} style={{"textAlign": "left"}}>
                                        Email<span className='star'>*</span>
                                    </Form.Label>
                                    <Col sm={10}>
                                        <Form.Control type="email" placeholder="" />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                    <Form.Label column sm={2} style={{"textAlign": "left"}}>
                                        Address
                                    </Form.Label>
                                    <Col sm={10}>
                                        <Form.Control type="text" placeholder="" />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                    <Form.Label column sm={2} style={{"textAlign": "left"}}>
                                        City
                                    </Form.Label>
                                    <Col sm={10}>
                                        <Form.Control type="text" placeholder="" />
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                    <Form.Label column sm={2} style={{"textAlign": "left"}}>
                                        State
                                    </Form.Label>
                                    <Col sm={10}>
                                        <Form.Select aria-label="Default select example">
                                            <option>Select a state...</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                            <option value="3">Three</option>
                                        </Form.Select>
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                    <Form.Label column sm={2} style={{"textAlign": "left"}}>
                                        Zip / Postal Code
                                    </Form.Label>
                                    <Col sm={10}>
                                        <Form.Control type="text" placeholder="" />
                                    </Col>
                                </Form.Group>
                                 
                                <div className='text-center'>
                                <Button className='common-btn'>Submit</Button>{' '}
                                </div>
                            </Form>
                            <hr />
                            <p>You have (1) Platinum and (1) Gold guests on your list.</p>
                            <Table>
                                <thead>
                                    <tr>
                                       
                                        <th>TYPE</th>
                                        <th>GUEST NAME / EMAIL </th>
                                        <th>ADDRESS</th>
                                        <th> </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                         
                                        <td>Platinum</td>
                                        <td>
                                            <h7>Tracie Eisworth</h7>
                                            <p>tracieeisworth@att.net</p>
                                            <p><i>-Email Electronic Pass to Gallery</i></p>
                                        </td>
                                        <td>
                                            <p>
                                                149 Aspen Square<br />
                                                Denham Springs, LA70726<br />
                                                United States
                                            </p>
                                        </td>
                                        <td className="table-close">
            <Link to="/"><FontAwesomeIcon icon={faXmark} /></Link>
            </td>
                                    </tr>
                                    <tr>
                                        
                                        <td>Gold</td>
                                        <td>
                                            <h7>Kellye Eisworth</h7>
                                            <p>kellyeeisworth@gmail.com</p>
                                            <p><i>-Email Electronic Pass to Guest</i></p>
                                        </td>
                                        <td>
                                            <p>
                                                2496 SUTTER STREET<br />
                                                SAN FRANCISCO, CA94115<br />
                                                United States
                                            </p>
                                        </td>
                                        <td className="table-close">
            <Link to="/"><FontAwesomeIcon icon={faXmark} /></Link>
            </td>
                                    </tr>
                                </tbody>
                            </Table>
                  </div>
            </div>
         </div>
      </div>
   </div>
</section>  

 
</>
)
}
